/**
 * Liefert den Montag der aktuellen Woche.
 * @returns date Montag der Woche
 */
export const getMondayOfTheWeek = (): Date => {
  const date = new Date();
  const day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1);
  return new Date(date.setDate(diff));
};

/**
 * Liefert den Samstag der aktuellen Woche.
 * @returns date Samstag der Woche
 */
export const getSaturdayOfTheWeek = (): Date => {
  const date = new Date();
  const day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 6);
  return new Date(date.setDate(diff));
};

/**
 * @param isodate 2021-10-15T12:15:03Z
 * @returns Uhrzeit im Format 12:15
 */
export const isoDateToTime = (
  isodate: string | number | Date | undefined
): string => {
  let date;
  let time = '';
  if (isodate) {
    date = new Date(isodate);
    time = date.toLocaleTimeString('de', {
      timeZone: 'UTC',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  return time === '00:00' ? '' : time;
};
